'use client';

import {useState} from 'react';
import TabBar from 'common/components/tab_bar';
import type {ExperienceGate} from 'common/experiments';
import {TabKey} from 'common/types';
import {InterviewExperiencesTab} from 'iq-interview_experiences/components/interview_experiences_tab';
import type {InterviewGuideData, InterviewGuideTabProps} from 'iq-interview_guides/types';
import {ProcessOverviewTab} from 'iq-interview_process/components/process_overview_tab';
import {QuestionsTab} from 'iq-questions/components/practice_questions_tab';
import {FC} from 'node_modules/@types/react';

const TAB_KEYS: TabKey[] = ['interview_experiences', 'questions', 'interview_process'];

const tabs: Record<TabKey, FC<InterviewGuideTabProps>> = {
  interview_experiences: InterviewExperiencesTab,
  questions: QuestionsTab,
  interview_process: ProcessOverviewTab,
};

interface InterviewGuideTabsProps {
  initialTab: TabKey;
  interviewGuide: InterviewGuideData;
  experienceGate?: ExperienceGate | null;
}

export default function InterviewGuideTabs({
  initialTab,
  interviewGuide,
  experienceGate,
}: InterviewGuideTabsProps) {
  const questionCount = interviewGuide.questions.length;

  const [activeTab, setActiveTab] = useState<TabKey>(
    TAB_KEYS.includes(initialTab) ? initialTab : 'interview_experiences',
  );

  function handleTabChange(tab: TabKey) {
    setActiveTab(tab);
    window.history.pushState(null, '', `?tab=${tab}`);
  }

  const tabLabels: {key: TabKey; label: string}[] = [
    {
      key: 'interview_experiences',
      label: `Candidate Reports (${interviewGuide.experiences.length})`,
    },
    {
      key: 'questions',
      label: `Practice Questions (${questionCount + 1})`,
    },
    {key: 'interview_process', label: 'Process Overview'},
  ];

  return (
    <div className='max-w-[800] max-[960px]:max-w-full'>
      <TabBar tabs={tabLabels} activeTab={activeTab} onTabChange={handleTabChange} />

      <div className='py-8'>
        {TAB_KEYS.map((key) => {
          const Component = tabs[key];
          return (
            <div key={key} className={activeTab !== key ? 'hidden' : ''}>
              <Component
                isActive={activeTab === key}
                interviewGuide={interviewGuide}
                experienceGate={experienceGate}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
